import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import { axiosPath } from "../../../../routing/helpers/router";
import CommunicationPipelineUserNavbar from "../../../../layout/screenSpecifics/Modules/CommunicationPipeline/User/CommunicationPipelineUserNavbar";
import CommunicationPipelineUserReportSentDefaultTemplate from "../../../../layout/screenSpecifics/Modules/CommunicationPipeline/User/CommunicationPipelineUserReportSentTemplates/CommunicationPipelineUserReportSentDefaultTemplate";
import CommunicationPipelineUserReportSentHaizeaTemplate from "../../../../layout/screenSpecifics/Modules/CommunicationPipeline/User/CommunicationPipelineUserReportSentTemplates/CommunicationPipelineUserReportSentHaizeaTemplate";
import { AppModal, AppNoInfo } from "@/layout/AppComponents";
import CommunicationPipelineLogin from "@/layout/screenSpecifics/Modules/CommunicationPipeline/CommunicationPipelineLogin";
import errorHandler from "@/layout/components/error/ErrorHandler";
import CommunicationPipelineModuleSidebar from "@/layout/screenSpecifics/Modules/CommunicationPipeline/CommunicationPipelineModuleSidebar";
import * as currentPageAction from "../../../../store/actions/currentPageAction";

export default function CommunicationPipelineUserReportSentScreen() {
  const { moduleBridgeHex, reportHex } = useParams();
  const dispatch = useDispatch();
  const reportTemplate = useSelector(
    (state) => state.currentPage?.moduleData?.reportTemplate,
  );
  const [report, setReport] = useState();
  const authReports = useSelector((state) => state.currentPage?.reports) || [];
  const [isAuth, setIsAuth] = useState(false);
  const moduleData = useSelector((state) => state.currentPage?.moduleData);

  const loadReport = useCallback(async () => {
    axios
      .post(axiosPath("api_r_user_module_communicationPipeline_report_get"), {
        moduleBridgeHex,
        reportHex,
      })
      .then((r) => {
        setReport(r?.data);
      })
      .catch((e) => dispatch(errorHandler(e)));
  }, [moduleBridgeHex, reportHex]);

  useEffect(() => {
    if (reportHex && authReports.includes(reportHex)) {
      setIsAuth(true);
    }
  }, []);

  useEffect(() => {
    loadReport();
  }, []);

  const renderTemplate = useCallback(() => {
    switch (reportTemplate) {
      case "haizea":
        return (
          <CommunicationPipelineUserReportSentHaizeaTemplate report={report} />
        );
      default:
        return (
          <CommunicationPipelineUserReportSentDefaultTemplate report={report} />
        );
    }
  }, [reportTemplate, report]);

  // > LOAD MODULE DATA //
  useEffect(() => {
    axios
      .post(
        axiosPath("api_r_user_module_communicationPipeline_getModuleData"),
        { moduleBridgeHex },
      )
      .then((r) => {
        dispatch(currentPageAction.change("moduleData", r.data, true));
      });
  }, []);
  // > LOAD MODULE DATA //

  if (!moduleData) return <AppNoInfo />;

  if (isAuth === false) {
    return (
      <>
        {moduleData?.permissionLevel === 0 && (
          <CommunicationPipelineModuleSidebar />
        )}
        <AppModal show={isAuth === false} isCloseButton={false}>
          <CommunicationPipelineLogin onAuth={() => setIsAuth(true)} />
        </AppModal>
      </>
    );
  }

  return (
    <>
      {moduleData?.permissionLevel === 0 && (
        <CommunicationPipelineModuleSidebar />
      )}
      <Container>
        <CommunicationPipelineUserNavbar />
        {report && renderTemplate()}
      </Container>
    </>
  );
}

const Container = styled.div`
  padding-left: 0.5rem !important;
  padding-bottom: 100px;
  h3 {
    font-size: 14px;
    font-weight: 700;
    margin: 32px 0 0 0;
  }
  .minHeight600 {
    min-height: 600px;
  }
  .user-info {
    border: 1px solid lightgray;
    padding: 24px;
  }
`;
